import React from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CircularProgress 
} from "@mui/material";

export default function QuizRotation({
  questions,
  currentIdx,
  setCurrentIdx,
  answers,
  setAnswers, // 👈 This is actually your `updateAnswer` helper from App.jsx
  grade,
  feedback,
  handleSingleGrade,
  handleGradeAll,
  loadingGradeSingle,
  loadingGradeAll,
}) {
  const q = questions[currentIdx];
  if (!q) return null;
  console.log("Rendering question:", q);
  return (
    <Box sx={{ mt: 3 }}>
      {/* Question header */}
      <Typography variant="h6" gutterBottom>
        Question {currentIdx + 1} of {questions.length}
      </Typography>

      {/* Question text */}
      <Typography variant="body1" gutterBottom>
        {q.question}
      </Typography>

      {/* ✅ FIXED: Answer input now works with your object-based `answers` */}
      {q.type === "ShortAnswer" && (
        <TextField
          fullWidth
          variant="outlined"
          value={answers[currentIdx] || ""}
          onChange={(e) => setAnswers(currentIdx, e.target.value)} // ✅ Use helper directly
          placeholder="Type your answer..."
          sx={{ my: 2 }}
        />
      )}      
      
      {q.type === "MCQ" && Array.isArray(q.options) && (
  <RadioGroup
    value={answers[currentIdx] || ""}
    onChange={(e) => setAnswers(currentIdx, e.target.value)}
    sx={{ my: 2 }}
  >
    {q.options.map((opt, i) => (
      <FormControlLabel
        key={i}
        value={opt}
        control={<Radio />}
        label={opt}
      />
    ))}
  </RadioGroup>
)}

      {/* Single grade button */}
      {!feedback[currentIdx] && (
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          sx={{ mt: 2 }}
          onClick={handleSingleGrade}
          disabled={loadingGradeSingle}
        >
          Grade This
        </Button>
         {loadingGradeSingle && <CircularProgress size={18} />}
         </Box>
      )}

      {/* Feedback display */}
      {feedback[currentIdx] && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Feedback:
          </Typography>

          <Card variant="outlined" sx={{ p: 2, backgroundColor: "#f9f9f9" }}>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              Grade: {feedback[currentIdx].grade}
            </Typography>

            <Typography variant="body2" sx={{ mt: 1 }}>
              Feedback: {feedback[currentIdx].feedback}
            </Typography>

            {feedback[currentIdx].expected_answer && (
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontStyle: "italic",
                  color: "#1976d2",
                }}
              >
                <strong>Expected Answer:</strong>{" "}
                {feedback[currentIdx].expected_answer}
              </Typography>
            )}
          </Card>
        </Box>
      )}

      {/* Navigation buttons */}
      <Box sx={{ mt: 3 }}>
        {currentIdx > 0 && (
          <Button
            variant="outlined"
            sx={{ mr: 2 }}
            onClick={() => setCurrentIdx((i) => i - 1)}
          >
            Previous
          </Button>
        )}
        {currentIdx < questions.length - 1 && (
          <Button variant="outlined" onClick={() => setCurrentIdx((i) => i + 1)}>
            Next
          </Button>
        )}
      </Box>

      {/* Grade all remaining button */}
      {currentIdx === questions.length - 1 && (
        
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
          <Button
            variant="contained"
            onClick={handleGradeAll}
            disabled={loadingGradeAll}
          >
            Grade All Remaining
          </Button>
          {loadingGradeAll && <CircularProgress size={20} />}
        </Box>
      )}
    </Box>
  );
}

